<template>
  <div>
    <iModal :title="modelTitle" v-model="showModal" class-name="my-modal" width="800px" :mask-closable="false"
      @on-cancel="cancel">
      <Input search enter-button placeholder="请输入关键字" style="width:300px" v-model="searchField"
        @on-search="searchHandle()" />
      <div class="box">
        <Row :gutter="20">
          <Col span="8" v-for="(item, index) in list" :key="index">
          <div class="item" @click="selectHandle(item)"
            :class="{ hasSelect: selectArr.indexOf(item.id) !== -1, select: selectId === item.id }">
            <img :src="item.banner[0]" class="item-banner">
            <div class="item-modal">
              <img class="item-modal-select" src="@/assets/img/select.png" />
            </div>
          </div>
          <p class="txt1" :title="item.name">{{ item.name }}</p>
          </Col>
        </Row>
        <div class="my-page" v-if="totalCount > pageSize">
          <Page show-total show-elevator :page-size="pageSize" :current="pageIndex" :total="totalCount"
            @on-change="changePage" @on-page-size-change="changePageSize" />
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" :loading="loading" @click="handleSubmit">确定</Button>
        <Button @click="cancel">取消</Button>
      </div>
    </iModal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "add-product",
  components: {
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: []
    },
    modelTitle: {
      type: String,
    }
  },
  data () {
    let that = this;
    return {
      loading: false,
      showModal: false,
      pageSize: 6,
      pageIndex: 1,
      totalCount: 0,
      selectArr: [],
      selectObj: null,
      list: [],
      selectId: '',
      searchField: '',
    };
  },
  watch: {
    show (val, oldVal) {
      this.showModal = val;
      if (val) {
        this.init();
      } else {
        this.$emit("close");
      }
    },
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
      hostExhibition: "hostSetModule/getHostExhibition"
    }),
    activityId () {
      return this.$route.query.activityId;
    },
    channelId () {
      return this.$route.query.channelId;
    },
    isExhibition () { // 是否时展商入口
      return this.$route.query.isExhibition;
    },
    exOption () {
      return {
        CompId: this.company.id,
        PageSize: this.pageSize,
        PageIndex: this.pageIndex,
        Wheres: {
          type: 0,
          wheres: {
            WhereGroupOperator: 0,
            Predicates: [
              {
                type: 1,
                wheres: {
                  WhereOperator: 6,
                  Label: "Name",
                  Value: `%${this.searchField}%`
                }
              }
            ]
          }
        }
      };
    },
    option () {
      return {
        ExhibitionId: this.hostExhibition.id,
        PageSize: this.pageSize,
        PageIndex: this.pageIndex,
        Wheres: {
          type: 0,
          wheres: {
            WhereGroupOperator: 0,
            Predicates: [
              {
                type: 1,
                wheres: {
                  WhereOperator: 6,
                  Label: "Name",
                  Value: `%${this.searchField}%`
                }
              }
            ]
          }
        }
      };
    },
  },
  methods: {
    ...mapActions({
      getProduct: "productModule/getProduct",
      getHostProductByExId: "productModule/getHostProductByExId",
      transportProduct: "liveModule/transportProduct",
    }),
    searchHandle () {
      this.pageIndex = 1;
      this.init();
    },
    async init () {
      this.selectArr = [];
      let proData = null;
      if (this.isExhibition) { // 展商
        proData = await this.getProduct(this.exOption);
      } else { // 主办
        proData = await this.getHostProductByExId(this.option);
      }
      console.log('this.options', this.options);
      if (proData) {
        proData.items.map(c => {
          if (c.banner) {
            c.banner = JSON.parse(c.banner);
          } else {
            c.banner = [];
          }
          this.options.forEach(v => {
            if (c.name === v.name) {
              this.selectArr.push(c.id);
            }
          });
        });
        this.list = proData.items;
        this.pageSize = proData.pageSize;
        this.pageIndex = proData.pageIndex;
        this.totalCount = proData.totalCount;
      }
    },
    async handleSubmit () {
      if (!this.selectObj) {
        this.$Message.error("请选择产品");
        return;
      }
      this.loading = true;
      let opt = {
        activityId: this.activityId,
        productId: this.selectObj.id,
        request: {
          channelId: this.channelId,
          name: this.selectObj.name,
          status: 1,
          linkType: 11,
          realPrice: 0,
          wxMiniprogramOriginalId: 'wxe41003ebfec74559', // cmef 小程序id 
          wxMiniprogramLink: `/pages/subpages/product/pro-details/main?proId=${this.selectObj.id}&activityId=${this.activityId}&companyId=${this.selectObj.compId}`, // cmef 小程序id 
          cover: this.selectObj.banner[0],
        }
      }
      console.log(opt);
      let bool = await this.transportProduct(opt);
      this.loading = false;
      if (bool && bool.data && bool.data.polyv && bool.data.polyv.transportProduct) {
        this.cancel();
        this.$Message.success("操作成功！");
        setTimeout(c => {
          this.$emit("finish");
        }, 1000);
      } else {
        let err = "操作失败，请重新尝试";
        if (bool.errors && bool.errors[0]) {
          err = bool.errors[0].message;
        }
        this.$Message.error(err);
      }
    },
    cancel () {
      this.list = [];
      this.selectId = '';
      this.selectArr = [];
      this.selectObj = null;
      this.searchField = '';
      this.pageIndex = 1;
      this.$emit("close");
    },
    selectHandle (item) {
      this.selectId = item.id;
      this.selectObj = item;
    },
    changePage (e) {
      this.pageIndex = e;
      this.init();
    },
    changePageSize (e) {
      this.pageSize = e;
      this.init();
    },
  }
};
</script>

<style scoped lang="scss">
/deep/ {
  .ivu-input-search {
    background: #d13119 !important;
    border-color: #d13119 !important;
  }
}

.my-page {
  height: 50px;
  padding: 30px 0 0;
  text-align: center;
}

.box {
  padding: 40px 20px;
}

.item {
  width: 100%;
  padding-bottom: 80%;
  position: relative;
  cursor: pointer;

  &.hasSelect {
    .item-modal-select {
      display: block;
      opacity: 0;
    }
  }

  &.select {
    .item-modal-select {
      display: block;
    }
  }

  &.select,
  &.hasSelect,
  &:hover {
    .item-modal {
      display: block;
    }
  }

  &-banner {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    max-width: 100%;
    max-height: 100%;
    z-index: 1;
  }

  &-modal {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    margin: auto;
    font-size: 14px;
    color: #fff;
    cursor: pointer;
    background-color: rgba(55, 55, 55, .6);
    text-align: center;
    padding-top: calc(50% - 30px);

    &-select {
      width: 20px;
      position: absolute;
      bottom: 0;
      right: 0;
      display: none;
    }
  }
}

.txt1 {
  line-height: 40px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>

